import getParamsFromString from "../../../../../Utils/getParamsFromString";

export const creatingFilter = (action, globalValues, screenName) => {
    /* eslint-disable */
    if (action.paramType === 'script') {
        let newFilter = getParamsFromString(action.script, globalValues, screenName);
        if (newFilter && Array.isArray(newFilter)) {
            let checkedFilter = [];
            newFilter.forEach(filter => {
                checkedFilter.push({
                    ...filter,
                    value: getParamsFromString(filter.value, globalValues, screenName),
                    value2: getParamsFromString(filter.value2, globalValues, screenName)
                })
            });
            return checkedFilter;
        }
        return []
    }
    let newFilter = [];
    (action.param || []).forEach(item => {
        let newFilterItem = {};
        Object.keys(item).forEach(key => {
            if (key === 'value') {
                //value
                newFilterItem.value = paramToValue(item[key], globalValues, screenName)
            } else if (key === 'value2') {
                newFilterItem.value2 = paramToValue(item[key], globalValues, screenName)
            } else if (key === 'column') {
                //column
                newFilterItem.field = item[key]
            } else if (key === 'operand') {
                //operand
                newFilterItem[key] = item[key]
            }
        });
        if (newFilterItem.value !== undefined && newFilterItem.value !== "" && newFilterItem.value !== "undefined") {
            newFilter.push(newFilterItem)
        }
    });
    return newFilter;
    /* eslint-enable */
};
export const paramToValue = (params = [], globalValues, screenName) => {
    let values = [];
    let isArr = Array.isArray(params) ? params : [params];
    isArr.forEach(param => {
        if (param !== undefined) {
            if (Array.isArray(params) && params.length > 1) {
                values.push(getParamsFromString(param, globalValues, screenName))
            } else {
                values = getParamsFromString(param, globalValues, screenName)
            }
        }
    });
    return values;
};